import { useState } from 'react';

const CircleCloseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [mouseEnter, setMouseEnter] = useState<boolean>(false);

  const handleMouseEnter = (e: any) => {
    e.stopPropagation();
    setMouseEnter(true);
  };

  const handleMouseLeave = (e: any) => {
    e.stopPropagation();
    setMouseEnter(false);
  };

  return (
    <svg
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g opacity={mouseEnter ? '1' : '0.6'}>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.9679 5.02574C11.2022 5.26005 11.2022 5.63995 10.9679 5.87426L8.84844 7.99375L10.9717 10.117C11.206 10.3513 11.206 10.7312 10.9717 10.9655C10.7374 11.1998 10.3575 11.1998 10.1232 10.9655L7.99991 8.84228L5.87675 10.9654C5.64244 11.1997 5.26254 11.1997 5.02823 10.9654C4.79391 10.7311 4.79391 10.3512 5.02823 10.1169L7.15138 7.99375L5.03199 5.87435C4.79767 5.64004 4.79767 5.26014 5.03199 5.02583C5.2663 4.79151 5.6462 4.79151 5.88051 5.02583L7.99991 7.14522L10.1194 5.02574C10.3537 4.79142 10.7336 4.79142 10.9679 5.02574Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default CircleCloseIcon;
